import { GestureTapBoxIcon } from './GestureTapBoxIcon';

/**
 * author: Michael Irigoyen
 * id FC2EE3B3-9885-4278-9BCE-491B27B4666E
 * name gesture-tap-box
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture-tap-box.svg
 * tags
 */
export const GestureTouchBoxIcon = GestureTapBoxIcon;
export default GestureTouchBoxIcon